module.exports = {
      id: "sort-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#sort",
      toString: function () {
        return this.url;
      }
    }